export default "__VITE_ASSET__Dj1NJq0A__"